import { useCallback, useEffect, useState } from 'react'
import { trackWithExtra } from '../../../../../lib/tracking'
import { BargainUserInfo } from '../../../../types'
import { FormData, validateForm } from '../utils/formValidation'

export const usePostForm = (bargain_user_info: BargainUserInfo, images?: File[]) => {
  const [formData, setFormData] = useState<FormData>({
    shopId: null,
    productName: '',
    comment: '',
    posterName: '',
    price: ''
  })
  
  const [isPreviewMode, setIsPreviewMode] = useState(false)
  const [isPostCompleted, setIsPostCompleted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState(false)
  const [isFormValid, setIsFormValid] = useState(false)

  // フォームデータの変更を監視してバリデーション状態を更新
  useEffect(() => {
    const validation = validateForm(formData, bargain_user_info, images)
    setIsFormValid(validation.isValid)
  }, [formData, bargain_user_info, images])

  const updateFormData = useCallback((updates: Partial<FormData>) => {
    setFormData(prev => ({ ...prev, ...updates }))
  }, [])

  const handleProductNameChange = (value: string) => {
    updateFormData({ productName: value })
  }

  const handleCommentChange = (value: string) => {
    updateFormData({ comment: value })
  }

  const handlePriceChange = (value: string) => {
    const numericValue = value.replace(/[^0-9.]/g, '')
    updateFormData({ price: numericValue })
  }

  const handlePosterNameChange = (value: string) => {
    updateFormData({ posterName: value })
  }

  const validateAndSetError = (): boolean => {
    const validation = validateForm(formData, bargain_user_info, images)
    setError(validation.error)
    return validation.isValid
  }

  const handleShowPreview = () => {
    if (validateAndSetError()) {
      void trackWithExtra('bargain.message_board.post.preview.imp', { path: location.pathname })
      setIsPreviewMode(true)
    }
  }

  const handleBackToEdit = () => {
    setIsPreviewMode(false)
  }

  const handlePostSuccess = () => {
    void trackWithExtra('bargain.message_board.post.complete.imp', { path: location.pathname })
    setSuccess(true)
    setIsPostCompleted(true)
  }

  return {
    formData,
    isPreviewMode,
    isPostCompleted,
    loading,
    error,
    success,
    isFormValid,
    setLoading,
    setError,
    updateFormData,
    handleProductNameChange,
    handleCommentChange,
    handlePriceChange,
    handlePosterNameChange,
    handleShowPreview,
    handleBackToEdit,
    handlePostSuccess,
    validateAndSetError,
  }
}
